import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
const includes = ['Exactamente qué alimentos darle y cuáles evitar, sin buscar en Google nunca más', 'Cuánto darle según su peso, para que nunca te quedes con la duda de si es mucho o poco', 'Cómo armar un plato balanceado completo sin necesitar conocimientos de nutrición', 'Cómo pasar del balanceado a lo natural sin que su panza lo rechace', 'Recetas simples que podés preparar en menos de 20 minutos', 'Un plan semanal completo listo para usar desde el primer día'];
export function ProductBreakdown() {
  return <section className="py-12 md:py-16 px-4 bg-cream" data-id="element-212">
      <div className="max-w-4xl mx-auto" data-id="element-213">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-center mb-12" data-id="element-214">
          <h2 className="text-3xl md:text-4xl font-bold text-charcoal mb-4" data-id="element-215">
            Dentro de Nutrición Canina Fácil vas a encontrar:
          </h2>
          <div className="w-24 h-1 bg-primary mx-auto rounded-full" data-id="element-216"></div>
        </motion.div>

        <div className="bg-white rounded-3xl shadow-soft p-8 md:p-12 border border-sage" data-id="element-217">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-218">
            {includes.map((item, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -10
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="flex items-start" data-id="element-219">
                <div className="mt-1 bg-sage rounded-full p-1 flex-shrink-0 mr-4" data-id="element-220">
                  <CheckIcon className="w-5 h-5 text-primary" data-id="element-221" />
                </div>
                <span className="text-lg text-gray-700 font-medium" data-id="element-222">
                  {item}
                </span>
              </motion.div>)}
          </div>
        </div>
      </div>
    </section>;
}